// Helpers for viewer-selectable soundtracks (movies and clips). A "viewer song"
// is a lightweight track the owner curates (up to 4); viewers pick one and it
// overlays live at playback.

// Normalize a library/YouTube/upload source into a stored viewer-song object.
export function buildViewerSong(makeId, src) {
  const dur = src.songDurationSec || src.durationSec || 0;
  const base = { id: makeId(), label: src.label || 'Song', songDurationSec: dur };
  return src.source === 'youtube'
    ? { ...base, source: 'youtube', videoId: src.videoId, thumb: src.thumb || '' }
    : { ...base, source: 'upload', url: src.url };
}

// Which option should play first: the saved default if it still exists,
// otherwise the first song, otherwise the movie/clip's own audio ('orig').
export function defaultSongChoice(viewerSongs, defaultId) {
  if (defaultId === 'orig') return 'orig';
  if (viewerSongs.some((s) => s.id === defaultId)) return defaultId;
  return viewerSongs[0]?.id || 'orig';
}
